export default "__VITE_ASSET__CxMlm7g1__"